import SwiperCore, { A11y, Autoplay, Pagination } from "swiper";

SwiperCore.use([A11y, Autoplay, Pagination]);
SwiperCore.extendDefaults({ a11y: { enabled: false } });

export const A11Y_PT_BR = {
  enabled: true,
  prevSlideMessage: "Slide anterior",
  nextSlideMessage: "Próximo slide",
  firstSlideMessage: "Este é o primeiro slide",
  lastSlideMessage: "Este é o último slide",
  paginationBulletMessage: "Ir para o slide {{index}}",
};
